import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useProaqModAquisicao = () => {
  const [proaqModAquisicao, setProaqModAquisicao] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchProaqModAquisicao = async () => {
      try {
        const response = await httpClient.get(`/api/proaq/modalidadeaquisicao`);

        const options = response.data.map(
          (proaqModAquisicao: { value: number; label: string }) => ({
            value: proaqModAquisicao.value.toString(),
            label: proaqModAquisicao.label,
          }),
        );
        setProaqModAquisicao(options);
      } catch (error) {
        console.error(
          'Erro ao buscar Modalidade de Aquisição do Processo Aquisitivo',
          error,
        );
      }
    };

    fetchProaqModAquisicao();
  }, []);

  return proaqModAquisicao;
};
